import React, { useState } from 'react';
import Icon from '../AppIcon';


const QuickActions = ({ actions = [], position = 'bottom-right' }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const defaultActions = [
    {
      id: 'order-diagnostic',
      label: 'Order Diagnostic',
      icon: 'FlaskConical',
      onClick: () => console.log('Order Diagnostic clicked'),
      shortcut: 'Ctrl+L'
    },
    {
      id: 'prescribe',
      label: 'Prescribe',
      icon: 'Pill',
      onClick: () => console.log('Prescribe clicked'),
      shortcut: 'Ctrl+P'
    },
    {
      id: 'schedule',
      label: 'Schedule',
      icon: 'Calendar',
      onClick: () => console.log('Schedule clicked'),
      shortcut: 'Ctrl+S'
    },
    {
      id: 'document',
      label: 'Document',
      icon: 'FileText',
      onClick: () => console.log('Document clicked'),
      shortcut: 'Ctrl+D'
    }
  ];

  const actionsList = actions?.length > 0 ? actions : defaultActions;

  const getPositionClasses = () => {
    switch (position) {
      case 'bottom-right':
        return 'bottom-6 right-6';
      case 'bottom-left':
        return 'bottom-6 left-6';
      case 'top-right':
        return 'top-6 right-6';
      case 'top-left':
        return 'top-6 left-6';
      default:
        return 'bottom-6 right-6';
    }
  };

  const handleActionClick = (action) => {
    if (action?.onClick) {
      action?.onClick();
    }
    setIsExpanded(false);
  };

  return (
    <div className={`fixed ${getPositionClasses()} z-[100] hidden lg:block`}>
      {isExpanded && (
        <div className="absolute bottom-20 right-0 bg-card rounded-xl shadow-elevation-4 border border-border p-2 min-w-[200px] space-y-1">
          {actionsList?.map((action) => (
            <button
              key={action?.id}
              onClick={() => handleActionClick(action)}
              className="flex items-center justify-between w-full px-4 py-3 rounded-lg text-sm font-medium text-foreground transition-smooth hover:bg-muted"
            >
              <div className="flex items-center gap-3">
                <Icon name={action?.icon} size={18} />
                <span>{action?.label}</span>
              </div>
              {action?.shortcut && (
                <span className="text-xs text-muted-foreground font-mono">
                  {action?.shortcut}
                </span>
              )}
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="quick-action-btn"
        aria-label="Quick actions"
      >
        <Icon name={isExpanded ? 'X' : 'Zap'} size={24} />
      </button>
    </div>
  );
};

export default QuickActions;